import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const australianStates = ['All States', 'NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT'];

const SearchFilterBar = ({ searchQuery, onSearchChange, selectedState, onStateChange, sortBy, onSortChange }) => {
  const { t } = useLanguage();

  const sortOptions = [
    { value: 'rating', label: t('topRated') },
    { value: 'reviews', label: t('mostReviews') },
    { value: 'price_asc', label: t('priceLowHigh') },
    { value: 'price_desc', label: t('priceHighLow') },
  ];

  return (
    <div className="flex flex-col md:flex-row gap-3">
      <div className="relative flex-1">
        <Icon name="Search" size={16} color="#6B9EC4" className="absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          type="text"
          placeholder={t('searchByNameSpec')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-10 pr-4 py-2.5 rounded-xl text-sm outline-none transition-all"
          style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(0,212,255,0.2)', color: '#E2E8F0' }}
        />
      </div>
      <select
        value={selectedState}
        onChange={(e) => onStateChange(e?.target?.value)}
        className="px-4 py-2.5 rounded-xl text-sm outline-none cursor-pointer"
        style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(0,212,255,0.2)', color: '#E2E8F0', minWidth: '140px' }}
      >
        {australianStates?.map((s) => (
          <option key={s} value={s} style={{ background: '#0D1B2A' }}>{s}</option>
        ))}
      </select>
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e?.target?.value)}
        className="px-4 py-2.5 rounded-xl text-sm outline-none cursor-pointer"
        style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(0,212,255,0.2)', color: '#E2E8F0', minWidth: '160px' }}
      >
        {sortOptions?.map((opt) => (
          <option key={opt?.value} value={opt?.value} style={{ background: '#0D1B2A' }}>{opt?.label}</option>
        ))}
      </select>
    </div>
  );
};

export default SearchFilterBar;
